export default __webpack_public_path__ + "static/media/cancel.a4483565.svg";